/* SOHLIVA – Fortschrittsbalken unter wischbaren Karussells. */
(function () {
  function bind(sec) {
    var list = sec.querySelector('.sm-prod__list, .sm-cols__list');
    var bar = sec.querySelector('.sm-bar i');
    if (!list || !bar || list.dataset.smBound) return;
    list.dataset.smBound = '1';
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var share = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
      bar.style.width = Math.max(share * 100, 12) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (list.scrollLeft / max) * (100 / share - 100) : 0) + '%)';
      sec.querySelector('.sm-bar').hidden = max < 2;
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function init() { document.querySelectorAll('.sm-prod, .sm-cols').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SOHLIVA – Produktkarten: mobil durch die Fotos wischen (Tipp öffnet weiter das Produkt).
   Am ersten/letzten Foto wird die Geste an das umgebende Karussell weitergegeben. */
(function () {
  function bind(box) {
    if (box.dataset.smSwipe === '1') return;
    box.dataset.smSwipe = '1';
    var track = box.querySelector('.sm-card__track');
    var dots = box.querySelectorAll('.sm-card__dots i');
    var n = track ? track.children.length : 0;
    if (n < 2) return;
    var i = 0, x0 = 0, y0 = 0, dx = 0, mode = null, moved = false;
    function go(k) {
      i = Math.max(0, Math.min(n - 1, k));
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    box.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; dx = 0; mode = null; moved = false;
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      var t = e.touches[0], mx = t.clientX - x0, my = t.clientY - y0;
      if (mode === null) {
        if (Math.abs(mx) < 2 && Math.abs(my) < 2) return;
        var next = mx < 0 ? i < n - 1 : i > 0;
        mode = Math.abs(mx) > Math.abs(my) && next ? 'swipe' : 'pass';
        if (mode === 'swipe') track.classList.add('is-drag');
      }
      if (mode !== 'swipe') return;
      e.preventDefault(); moved = true; dx = mx;
      var w = box.clientWidth || 1;
      track.style.transform = 'translateX(' + (-i * 100 + (dx / w) * 100) + '%)';
    }, { passive: false });
    box.addEventListener('touchend', function () {
      if (mode !== 'swipe') return;
      track.classList.remove('is-drag');
      var w = box.clientWidth || 1;
      go(Math.abs(dx) > w * 0.18 ? i + (dx < 0 ? 1 : -1) : i);
    });
    box.closest('a').addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
  }
  /* Fotos 2–4 liegen außerhalb des sichtbaren Bildfelds und würden per lazy-load nie rechtzeitig geladen:
     sobald die Karte in die Nähe des Bildschirms kommt, alle ihre Fotos laden. */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      io.unobserve(en.target);
    });
  }, { rootMargin: '300px' }) : null;
  function init() {
    document.querySelectorAll('[data-sm-swipe]').forEach(function (box) {
      bind(box);
      if (io && !box.dataset.smIo) { box.dataset.smIo = '1'; io.observe(box); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SOHLIVA – Produktgalerie mobil: Zähler „‹ 1/32 ›“ unter dem Bild. */
(function () {
  function bind(gal) {
    var list = gal.querySelector('media-carousel');
    if (!list || gal.dataset.smCount) return;
    gal.dataset.smCount = '1';
    var items = function () { return Array.prototype.filter.call(list.querySelectorAll('.product-gallery__media'), function (m) { return !m.hidden; }); };
    if (items().length < 2) return;
    var box = document.createElement('div');
    box.className = 'sm-gcount';
    box.innerHTML = '<button type="button" aria-label="Vorheriges Bild"><svg width="8" height="12" viewBox="0 0 8 12"><path d="M7 1L2 6l5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button><span></span><button type="button" aria-label="Nächstes Bild"><svg width="8" height="12" viewBox="0 0 8 12"><path d="M1 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>';
    var label = box.querySelector('span'), prev = box.firstChild, next = box.lastChild;
    (gal.querySelector('.product-gallery__ar-wrapper') || list).insertAdjacentElement('afterend', box);
    /* Mitte der Liste: Bilder werden mittig ausgerichtet, nicht an den Rand geschoben. */
    function mid(r) { return r.left + r.width / 2; }
    function current() {
      var its = items(), x = mid(list.getBoundingClientRect()), best = 0, dist = Infinity;
      its.forEach(function (m, i) { var d = Math.abs(mid(m.getBoundingClientRect()) - x); if (d < dist) { dist = d; best = i; } });
      return { i: best, n: its.length, its: its };
    }
    function update() { var c = current(); label.textContent = (c.i + 1) + '/' + c.n; prev.disabled = c.i === 0; next.disabled = c.i === c.n - 1; }
    function go(step) { var c = current(), t = c.its[Math.max(0, Math.min(c.n - 1, c.i + step))]; list.scrollBy({ left: mid(t.getBoundingClientRect()) - mid(list.getBoundingClientRect()), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    list.addEventListener('carousel:change', function () { setTimeout(update, 50); });
    update();
  }
  function init() { document.querySelectorAll('product-gallery').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SOHLIVA – Countdown bis zu einem festen Enddatum (data-sm-countdown); nach Ablauf ausgeblendet. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    document.querySelectorAll('[data-sm-countdown]').forEach(function (el) {
      var left = Math.floor((new Date(el.dataset.smCountdown) - new Date()) / 1000);
      if (!(left > 0)) { el.hidden = true; return; }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      el.querySelector('b').textContent = (d ? d + ' T. ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      el.hidden = false;
    });
  }
  tick(); setInterval(tick, 1000);
  /* Beim Variantenwechsel ersetzt das Theme den Block: sofort (vor dem nächsten Zeichnen) neu füllen, sonst blinkt er. */
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && (n.matches('[data-sm-countdown]') || n.querySelector('[data-sm-countdown]'))) { tick(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* SOHLIVA – Kundinnen-Fotos auf der Produktseite laufen langsam von selbst (Pause beim Antippen). */
(function () {
  function bind(box) {
    var track = box.querySelector('.sm-ugcs__track');
    if (!track || box.dataset.smBound || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    box.dataset.smBound = '1';
    track.innerHTML += track.innerHTML; // Endlosschleife
    var pause = 0, last = 0, pos = 0;
    ['touchstart', 'mousedown', 'wheel'].forEach(function (e) { track.addEventListener(e, function () { pause = Date.now() + 3000; }, { passive: true }); });
    function step(t) {
      var dt = last ? t - last : 0; last = t;
      if (Date.now() > pause) {
        pos = track.scrollLeft + dt * 0.025;
        var half = track.scrollWidth / 2;
        if (pos >= half) pos -= half;
        track.scrollLeft = pos;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function init() { document.querySelectorAll('[data-sm-ugcs]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SOHLIVA – Vorteils-Karten: aktiven Punkt beim Wischen mitführen. */
(function () {
  function bind(list) {
    if (list.dataset.smBound) return;
    list.dataset.smBound = '1';
    var dots = list.parentNode.querySelectorAll('.sm-ben__dot');
    if (!dots.length) return;
    function update() {
      var cards = list.children, x = list.getBoundingClientRect().left + list.clientWidth / 2, best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) { var r = cards[i].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - x); if (d < dist) { dist = d; best = i; } }
      dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === best); });
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  }
  function init() { document.querySelectorAll('[data-sm-ben]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SOHLIVA – Trustoo-Bewertungen unter die Tabs (nach den Vorteils-Karten) verschieben; die App setzt sie direkt unter das Produkt. */
(function () {
  var t = 0;
  function place() {
    var w = document.getElementById('trustoo-widget-wrapper'), v = document.querySelector('[id$="__tabs"]') || document.querySelector('[id$="__vorteile"]');
    if (w && v && v.nextElementSibling !== w) v.insertAdjacentElement('afterend', w);
  }
  place();
  if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 50); }).observe(document.documentElement, { childList: true, subtree: true });
})();
